import { RouteInfo } from '../sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '{{spWebUrl}}/Network/Search',
    title: 'Search',
    icon: 'ng-tns-c1-0 ft-search',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: true,
    submenu: [],
  },
  {
    path: '#',
    title: 'Bidding',
    icon: 'ft-target',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [
      {
        path: '{{spWebUrl}}/Network/PendingBids',
        title: 'Pending Bids',
        icon: '',
        class: 'second-level',
        badge: '',
        badgeClass: '',
        isExternalLink: true,
        submenu: [],
      },
      {
        path: '{{spWebUrl}}/Network/ActiveBids',
        title: 'Active Bids',
        icon: '',
        class: 'second-level',
        badge: '',
        badgeClass: '',
        isExternalLink: true,
        submenu: [],
      },
      {
        path: '{{spWebUrl}}/Network/OutBids',
        title: 'Outbids',
        icon: '',
        class: 'second-level',
        badge: '',
        badgeClass: '',
        isExternalLink: true,
        submenu: [],
      },
    ],
  },
  {
    path: '#',
    title: 'Campaigns',
    icon: 'ft-bell',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [
      {
        path: '{{spWebUrl}}/Network/UpcomingCampaigns',
        title: 'Upcoming',
        icon: '',
        class: 'second-level',
        badge: '',
        badgeClass: '',
        isExternalLink: true,
        submenu: [],
      },
      {
        path: '{{spWebUrl}}/Network/ActiveCampaigns',
        title: 'Active',
        icon: '',
        class: 'second-level',
        badge: '',
        badgeClass: '',
        isExternalLink: true,
        submenu: [],
      },
    ],
  },
];
